import axios from "axios";
import React, { createContext, useContext, useEffect, useReducer } from "react";

import ProductsReducer, { Product } from "../reducers/ProductsReducer";
import { ProductsActionType } from "../utils/actions";
import { API_URL, Endpoints } from "../utils/constants";

interface ProductResponse {
  result: Product[];
}

const initialState = {
  productsLoading: false,
  productsError: false,
  products: [] as Product[],
  singleProductLoading: false,
  singleProductError: false,
  singleProduct: {} as Product,
};

const ProductsContext = createContext({
  productsLoading: false,
  productsError: false,
  products: [] as Product[],
  singleProductLoading: false,
  singleProductError: false,
  singleProduct: {} as Product,
  fetchProducts: (ids: number[]) => {},
  fetchSingleProduct: (id: number) => {},
  fetchAllProducts: () => {},
});

export const ProductsProvider = (props: any) => {
  const { children } = props;
  const [state, dispatch] = useReducer(ProductsReducer, initialState);

  const fetchProducts = async (ids: number[]) => {
    dispatch({ type: ProductsActionType.GetProductsBegin });
    try {
      //const response = await axios.get<ProductResponse>(
      //  `${API_URL}${Endpoints.Product}`,
      //  { params: { products: ids } }
      //);
      const response = await axios.get<ProductResponse>(
          `${API_URL}${Endpoints.Product}?${ids.map((id) => `products=${id}`).join('&')}`
      );
      const products = response.data;
      dispatch({
        type: ProductsActionType.GetProductsSuccess,
        payload: products.result as Product[],
      });
    } catch (error) {
      dispatch({ type: ProductsActionType.GetProductsError });
    }
  };

  const fetchSingleProduct = async (id: number) => {
    dispatch({ type: ProductsActionType.GetSingleProductBegin });
    try {
      const response = await axios.get<ProductResponse>(
        `${API_URL}${Endpoints.Product}`,
        { params: { products: id } }
      );
      const products = response.data;
      dispatch({
        type: ProductsActionType.GetSingleProductSuccess,
        payload: products.result as Product[],
      });
    } catch (error) {
      dispatch({ type: ProductsActionType.GetSingleProductError });
    }
  };

  const fetchAllProducts = async () => {
    dispatch({ type: ProductsActionType.GetProductsBegin });
    try {
      const response = await axios.get<ProductResponse>(
        `${API_URL}${Endpoints.AllProduct}`
      );
      const products = response.data;
      dispatch({
        type: ProductsActionType.GetProductsSuccess,
        payload: products.result as Product[],
      });
    } catch (error) {
      dispatch({ type: ProductsActionType.GetProductsError });
    }
  };

  useEffect(() => {
    fetchAllProducts();
  }, []);

  const contextValues = {
    ...state,
    fetchProducts,
    fetchSingleProduct,
    fetchAllProducts,
  };

  return (
    <ProductsContext.Provider value={contextValues}>
      {children}
    </ProductsContext.Provider>
  );
};

export const useProductsContext = () => {
  return useContext(ProductsContext);
};
